import React from 'react';
import { Svg, SvgProps } from '@utex/ui-kit';

export const IconAlfaBank = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      d="M12.398 3c1.272 0 1.672.879 2.007 1.756l3.546 9.351c.026.073.009.193-.108.236-.117.043-1.835.686-1.93.72a.186.186 0 0 1-.236-.107c-.036-.09-.748-1.99-.829-2.203h-4.9c-.076.212-.798 2.117-.83 2.203a.183.183 0 0 1-.237.107l-1.928-.72a.184.184 0 0 1-.11-.236c.122-.326 3.378-8.904 3.543-9.351C10.71 3.892 11.123 3 12.399 3zM6.582 18.598a.184.184 0 0 0-.186.183v2.037c0 .1.083.182.186.182h11.627a.183.183 0 0 0 .188-.182v-2.037c0-.1-.083-.183-.188-.183H6.582zm5.804-12.752l-1.656 4.79h3.34l-1.662-4.79h-.021z"
      fill="#EE2A23"
    />
  </Svg>
);

export const IconSberbank = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      d="M19.122 6.498c.427.552.79 1.153 1.078 1.79l-8.198 6.043-3.426-2.148V9.599l3.426 2.148 7.12-5.25z"
      fill="#21A038"
    />
    <path
      d="M5.08 12c0-.116.002-.232.008-.346l-2.077-.102a8.976 8.976 0 0 0 2.625 6.81L7.11 16.89A6.896 6.896 0 0 1 5.079 12z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M12.001 5.078c.116 0 .231.005.346.01l.103-2.077a8.976 8.976 0 0 0-6.814 2.625L7.11 7.109A6.896 6.896 0 0 1 12 5.079z"
      fill="url(#paint1_linear)"
    />
    <path
      d="M12 18.921c-.115 0-.23 0-.346-.009l-.104 2.077a8.97 8.97 0 0 0 6.81-2.625l-1.469-1.472a6.902 6.902 0 0 1-4.89 2.03z"
      fill="url(#paint2_linear)"
    />
    <path
      d="M15.901 6.286l1.75-1.29A8.96 8.96 0 0 0 11.997 3v2.079a6.886 6.886 0 0 1 3.904 1.207z"
      fill="url(#paint3_linear)"
    />
    <path
      d="M21 12a9.057 9.057 0 0 0-.141-1.613l-1.937 1.427V12a6.902 6.902 0 0 1-2.28 5.13l1.397 1.544A8.977 8.977 0 0 0 21 12z"
      fill="#21A038"
    />
    <path
      d="M12 18.921a6.905 6.905 0 0 1-5.13-2.28l-1.544 1.397A8.976 8.976 0 0 0 12 21V18.92z"
      fill="url(#paint4_linear)"
    />
    <path
      d="M7.36 6.87L5.962 5.326A8.976 8.976 0 0 0 3 12h2.08a6.904 6.904 0 0 1 2.28-5.13z"
      fill="url(#paint5_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="6.057"
        y1="18.103"
        x2="3.785"
        y2="11.537"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".14" stopColor="#F1E813" />
        <stop offset=".3" stopColor="#E6E418" />
        <stop offset=".58" stopColor="#C9DA26" />
        <stop offset=".89" stopColor="#A2CC39" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="6.23"
        y1="6.004"
        x2="12.082"
        y2="3.774"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".06" stopColor="#0FA7DF" />
        <stop offset=".54" stopColor="#0098F8" />
        <stop offset=".92" stopColor="#0290EA" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="11.413"
        y1="19.745"
        x2="18.03"
        y2="18.251"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".12" stopColor="#A2CC39" />
        <stop offset=".28" stopColor="#86C239" />
        <stop offset=".87" stopColor="#219F38" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="11.565"
        y1="3.696"
        x2="17.221"
        y2="5.442"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".06" stopColor="#0290EA" />
        <stop offset=".79" stopColor="#0C89CA" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="5.848"
        y1="17.785"
        x2="12.005"
        y2="20.086"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".13" stopColor="#F1E813" />
        <stop offset=".3" stopColor="#EAE616" />
        <stop offset=".53" stopColor="#D8DF1F" />
        <stop offset=".8" stopColor="#BAD52D" />
        <stop offset=".98" stopColor="#A2CC39" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1="3.775"
        y1="12.252"
        x2="6.246"
        y2="5.822"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".07" stopColor="#A2CC39" />
        <stop offset=".26" stopColor="#81C45E" />
        <stop offset=".92" stopColor="#0FA7DF" />
      </linearGradient>
    </defs>
  </Svg>
);

export const IconTinkoff = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      d="M10.857 9.494l-.618-.225-.113-.056 1.181-.732h2.082l1.18.732-.73.45-.394.618-.732.507-1.124-.225-.732-1.07z"
      fill="#fff"
    />
    <path
      d="M13.367 8.373l-.008.044-.02.01-.917.497-.045-.034-.023.022-.895-.484-.02-.01-.007-.045-.325-1.854-.012-.08c.008-.077.088-.21.337-.343.247-.132.594-.221.964-.221h.005c.371 0 .718.09.965.22.25.134.33.268.338.344l-.012.08-.325 1.854zm.066 2.027h2.019a2.052 2.052 0 0 0-.172.777v4.79c0 .51-.193.865-.477 1.099-.292.239-.698.365-1.14.365h-.156c-.116-.001-.218-.002-.306 0a1.643 1.643 0 0 0-.357.041 1.06 1.06 0 0 0-.444.243c-.141-.12-.276-.2-.446-.242a1.636 1.636 0 0 0-.356-.041c-.09-.002-.192-.002-.31-.002h-.153c-.44 0-.847-.125-1.139-.364-.285-.234-.478-.59-.478-1.098v-4.79c0-.281-.075-.542-.171-.778h2.021c.293.306.664.495 1.032.496.369 0 .74-.19 1.033-.496z"
      fill="#fff"
      stroke="#000"
      stroke-width=".5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.56 10.713c-.326.301-.732.495-1.16.496H12.4c-.427-.001-.833-.195-1.158-.496H9.83l-.034.1c.021.117.034.239.034.364v4.79c0 .42.155.685.364.857.224.184.556.294.94.294h.148c.12 0 .23 0 .324.002.135.003.279.013.424.05.14.034.26.089.369.157.11-.068.23-.123.37-.158.144-.036.288-.046.424-.05a10.976 10.976 0 0 1 .47 0c.386 0 .717-.111.94-.295.21-.171.364-.437.364-.856v-4.79c0-.127.013-.248.035-.365l-.035-.1H13.56z"
      fill="#FFDD2D"
    />
    <path
      d="M12.412 18.911h-.024a5.16 5.16 0 0 1-1.207-.155l-.317.853c.209.074.916.215 1.536.215.619 0 1.327-.142 1.535-.215l-.316-.853c-.264.077-.81.158-1.207.155zm2.397-.848c-.235.133-.762.332-1.068.425l.257.704a6.435 6.435 0 0 0 1.188-.44l-.534-.177.158-.511zm-4.819 0l.158.512-.534.177c.322.161.715.311 1.187.44l.257-.704c-.305-.093-.832-.292-1.068-.424zM12.4 5.293c.66 0 1.189.217 1.48.45 0 0 .088-.52.384-.978l-.532.06-.279-.588-.535.274L12.4 4l-.517.51-.536-.274-.277.588-.532-.06c.296.458.382.977.382.977.293-.232.82-.45 1.48-.45z"
      fill="#000"
    />
    <path
      d="M21.051 11.233a2.55 2.55 0 0 1-1.896-.963l-.062-.078-.002-.002-.002-.002 1.962 1.045zm0 0a1.35 1.35 0 0 1-.204.35.87.87 0 0 1-.698.345h-.036a1.313 1.313 0 0 1-.201-.024l-.32-.06.024.324c.035.474.213 1.476 1.123 1.868a.887.887 0 0 1-.731.363 1.22 1.22 0 0 1-.568-.131l-.32-.166-.043.358a3.736 3.736 0 0 1-.17.743c-.247.731-.055 1.27-.009 1.384a1.413 1.413 0 0 1-.287.032.864.864 0 0 1-.566-.206l-.283-.24-.116.352c-.064.195-.17.41-.354.597-.299.306-.74.48-1.362.488.051-.093.16-.349.198-.85.044-.605.27-.932.47-1.11l.277-.248-.335-.163a.593.593 0 0 1-.137-.088l-.001-.001a.749.749 0 0 1-.267-.532c.61-.013 1.066-.203 1.434-.627.086-.099.154-.198.21-.295l.314-.546-.603.182a1.96 1.96 0 0 1-.765.074 1.014 1.014 0 0 1-.517-.21c.295-.192.606-.477.785-.885.187-.428.216-.958-.022-1.6-.311-.839-1.02-1.57-2.106-2.25-.336-.211-.44-.411-.44-.534 0-.113.043-.186.112-.248.08-.072.188-.124.314-.182l.003-.001.019-.009c.051-.024.113-.053.168-.084a.726.726 0 0 0 .195-.149c.173-.2.163-.458.118-.646a1.44 1.44 0 0 0-.229-.492 1.421 1.421 0 0 1 1.192.412v.001c.287.296.32.602.306.798l-.018.247.247.02c.027.003.056.004.082.006l.028.001h.054c.357 0 .613-.189.769-.359.126-.137.201-.275.23-.335.025.034.076.11.122.215.067.151.117.347.085.557-.044.273-.217.53-.568.76a.987.987 0 0 0-.125.094l-.323.29.413.134c.657.212 1.029.673 1.47 1.23l1.962 1.046zm-17.31 0a2.55 2.55 0 0 0 1.896-.963l.063-.078.001-.002.003-.002-1.963 1.045zm0 0c.025.064.089.209.205.35a.87.87 0 0 0 .698.345h.035c.072-.002.137-.012.202-.024l.32-.06-.025.324c-.035.474-.213 1.476-1.122 1.868.07.097.297.363.73.363.248 0 .433-.061.568-.131l.32-.166.044.358c.024.198.073.455.17.743.247.731.055 1.27.008 1.384.054.012.163.032.287.032a.865.865 0 0 0 .566-.206l.283-.24.116.352c.065.195.171.41.354.597.3.306.741.48 1.362.488-.05-.093-.16-.349-.198-.85-.044-.605-.27-.932-.469-1.11l-.277-.248.334-.163a.59.59 0 0 0 .137-.088l.002-.001a.749.749 0 0 0 .267-.532c-.61-.013-1.067-.203-1.435-.627a1.875 1.875 0 0 1-.21-.295L6.7 13.15l.604.182a1.96 1.96 0 0 0 .764.074c.256-.023.447-.154.517-.21-.295-.192-.606-.477-.785-.885-.187-.428-.215-.958.023-1.6.31-.839 1.019-1.57 2.105-2.25.336-.211.44-.411.44-.534a.309.309 0 0 0-.112-.248 1.238 1.238 0 0 0-.314-.182l-.003-.001-.018-.009c-.052-.024-.113-.053-.169-.084a.726.726 0 0 1-.195-.149c-.172-.2-.162-.458-.117-.646a1.44 1.44 0 0 1 .228-.492 1.421 1.421 0 0 0-1.192.412v.001a1.007 1.007 0 0 0-.306.798l.019.247-.248.02a2.999 2.999 0 0 1-.081.006L7.83 7.6h-.055a1.04 1.04 0 0 1-.768-.359 1.489 1.489 0 0 1-.231-.335c-.025.034-.075.11-.121.215a1.009 1.009 0 0 0-.086.557c.044.273.217.53.568.76a.982.982 0 0 1 .125.094l.324.29-.414.134c-.657.212-1.029.673-1.47 1.23l-1.962 1.046z"
      fill="#fff"
      stroke="#000"
      stroke-width=".5"
    />
    <path
      d="M18.648 8.812c.32.17.505.395.667.596.16.195.312.384.55.462a.815.815 0 0 0 .264.042c.357 0 .715-.216.85-.516l.137-.301-.33-.02c-.016 0-.44-.039-.914-.52a.948.948 0 0 0-.683-.3c-.31 0-.54.153-.565.169l-.304.212.328.176zM4.668 9.913a.817.817 0 0 0 .266-.042c.239-.079.39-.267.55-.463.163-.2.347-.426.666-.595l.328-.175-.304-.213c-.026-.016-.255-.17-.563-.17a.945.945 0 0 0-.684.302c-.473.48-.897.519-.913.52l-.33.018.135.302c.137.299.494.516.85.516z"
      fill="#000"
    />
  </Svg>
);
